<template>
  <ul
    v-if="value.length > 0"
    class="list-disc ml-[10px] p-[4px]"
  >
    <li
      v-for="item in value"
      :key="item.id"
    >
      <span
        class="flex items-center justify-between gap-[8px]"
      >
        {{ item.name || '-' }}
        <span v-if="item.layer">x{{ item.layer }}</span>
      </span>
    </li>
  </ul>
  <p
    v-else
  >-</p>
</template>

<script>
export default {
  name: 'PackingSelection',
  props: {
    value: {
      type: Array,
      default: () => [],
    },
  },
}
</script>
